/**
 * Mixin global para funcionalidades de autenticação
 */

import { getCurrentUserRole } from '@/utils/menuPermissions'
import { getCurrentAuthState } from '@/utils/authSync'

export const authMixin = {
  computed: {
    currentUserRole() {
      return getCurrentUserRole()
    },
    
    isAdmin() {
      return this.currentUserRole === 'admin'
    },
    
    isDoctor() {
      return this.currentUserRole === 'doctor'
    },
    
    isTechnician() {
      return this.currentUserRole === 'technician'
    },
    
    isPatient() {
      return this.currentUserRole === 'patient'
    },
    
    authState() {
      return getCurrentAuthState()
    },
    
    currentUserInfo() {
      return this.authState.userInfo
    }
  },
  
  methods: {
    hasRole(role) {
      if (Array.isArray(role)) {
        return role.includes(this.currentUserRole)
      }
      return this.currentUserRole === role
    },
    
    hasAnyRole(roles) {
      return roles.some(role => this.hasRole(role))
    },
    
    canAccess(requiredRole) {
      if (!requiredRole) return true
      
      if (Array.isArray(requiredRole)) {
        return requiredRole.includes(this.currentUserRole)
      }
      
      return this.currentUserRole === requiredRole
    },
    
    refreshAuthState() {
      // Force reactive update
      this.$forceUpdate()
    }
  }
}

export default authMixin
